<template>
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" class="user-icon">
        <path d="M16.6519 15.01C16.0806 12.3715 14.2946 10.4239 11.9409 9.53969C13.1872 8.53598 13.9149 6.91352 13.6478 5.13637C13.3384 3.07622 11.6228 1.42563 9.55381 1.18481C6.69736 0.852585 4.27334 3.07622 4.27334 5.86762C4.27334 7.35298 4.9624 8.67485 6.03466 9.53969C3.68271 10.4239 1.89677 12.3715 1.32373 15.01C1.1163 15.9698 1.88798 16.868 2.8706 16.868H15.1032C16.0858 16.868 16.8593 15.9698 16.6519 15.01V15.01ZM5.84482 5.86762C5.84482 4.13442 7.25459 2.72466 8.98779 2.72466C10.721 2.72466 12.1308 4.13442 12.1308 5.86762C12.1308 7.60083 10.721 9.01059 8.98779 9.01059C7.25459 9.01059 5.84482 7.59907 5.84482 5.86762ZM14.0397 15.2965H3.93759C3.39443 15.2965 2.99189 14.7481 3.19755 14.2454C4.14853 11.9145 6.38447 10.5821 8.98779 10.5821C11.5929 10.5821 13.827 11.9163 14.778 14.2454C14.9854 14.7481 14.5829 15.2965 14.0397 15.2965V15.2965Z" fill="currentColor" />
    </svg>

</template>

<script>
    export default {
        name: 'UserIcon'
    }
</script>

<style scoped>
    svg {
        height: 100%;
    }
</style>
